// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.image-viewer[data-v-b5ed679c] {\n  display: inline-block;\n}\n.image-placeholder[data-v-b5ed679c],\n.image-error[data-v-b5ed679c],\n.image-empty[data-v-b5ed679c] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  background: #f5f7fa;\n  border-radius: 4px;\n  color: #909399;\n  font-size: 12px;\n}\n.image-error[data-v-b5ed679c] {\n  color: #f56c6c;\n}\n.image-empty[data-v-b5ed679c] {\n  color: #c0c4cc;\n}\n", ""]);
// Exports
module.exports = exports;
